<template>
    <div>
        <Header/>
        <!-- Carousel -->
        <div id="carouselExampleIndicators" class="carousel slide carousel-fade" data-ride="carousel">
            <ol class="carousel-indicators">
                <li data-target="#carouselExampleIndicators" v-for="(banner,index) in banners" :key="banner.index" v-bind:class="((index) === 0) ? 'active' : ++index" data-slide-to="{index}"></li>
            </ol>
            <div class="carousel-inner">
                <div class="carousel-item" v-for="(banner,index) in banners" :key="banner.index" v-bind:class="((index) === 0) ? 'active' : ''">
                    <img class="img-fluid" :src="getImgBanner(banner.path_file)">
                    <div class="carousel-caption">
                        <h2 class="text-bold text-orange" data-aos="fade-left">{{banner.banner_title}}</h2>
                        <p class="text-facebook text-bold" data-aos="fade-left">{{banner.banner_sub}}</p>
                        <!-- <router-link to="/products" class="btn btn-order btn-lg text-light" data-aos="fade-up">สั่งสินค้า</router-link> -->
                    </div> 
                </div>
            </div>
            <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                <span><i class="fas fa-chevron-left fa-3x text-orange"></i></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                <span><i class="fas fa-chevron-right fa-3x text-orange"></i></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
        <!-- Boby -->
        <div class="container mt-7">
            <div class="text-center">
                <h2 class="text-bold text-orange">PRODUCTION AND DISTRIBUTION OF FOOD BOXED</h2>
                <p>ผลิต จำหน่ายบรรจุภัณฑ์ กล่องข้าวกระดาษ และจัดส่งกล่องสำหรับใส่อาหาร</p>
            </div>
            <div class="row">
                <div class="col-md-3 dotted p-2" data-aos="zoom-in">
                    <div class="text-center">
                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" width="50" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><polygon style="fill:#FFD200;" points="256,438.716 444.19,438.716 496.988,343.339 235.984,323.323 "/><polygon style="fill:#FFF9BF;" points="15.012,343.339 67.81,438.716 256,438.716 256,323.323 "/><polygon style="fill:#FFD200;" points="256,247.962 235.984,295.597 256,343.339 496.988,343.339 444.19,247.962 "/><polygon style="fill:#FFF9BF;" points="256,247.962 67.81,247.962 15.012,343.339 256,343.339 "/><g><path style="fill:#E0E3E6;" d="M159,212.284h-30c0-15.238,4.259-23.46,7.681-30.067c2.693-5.2,4.319-8.339,4.319-16.269s-1.626-11.069-4.319-16.269c-3.422-6.606-7.681-14.829-7.681-30.066s4.259-23.458,7.681-30.064C139.374,84.35,141,81.212,141,73.284h30c0,15.237-4.259,23.458-7.681,30.064c-2.693,5.199-4.319,8.337-4.319,16.265c0,7.93,1.626,11.068,4.319,16.269c3.422,6.606,7.681,14.829,7.681,30.067s-4.259,23.46-7.681,30.066C160.626,201.215,159,204.354,159,212.284z"/><path style="fill:#E0E3E6;" d="M229.667,212.284h-30c0-15.238,4.259-23.46,7.681-30.067c2.693-5.2,4.319-8.339,4.319-16.269s-1.626-11.069-4.319-16.269c-3.422-6.606-7.681-14.829-7.681-30.066s4.259-23.458,7.681-30.064c2.693-5.199,4.319-8.337,4.319-16.265h30c0,15.237-4.259,23.458-7.681,30.064c-2.693,5.199-4.319,8.337-4.319,16.265c0,7.93,1.626,11.068,4.319,16.269c3.422,6.606,7.681,14.829,7.681,30.067s-4.259,23.46-7.681,30.066C231.292,201.215,229.667,204.354,229.667,212.284z"/></g><g><path style="fill:#C7C5CA;" d="M300.333,212.284h-30c0-15.238,4.259-23.46,7.681-30.067c2.693-5.2,4.319-8.339,4.319-16.269s-1.626-11.069-4.319-16.269c-3.422-6.606-7.681-14.829-7.681-30.066s4.259-23.458,7.681-30.064c2.693-5.199,4.319-8.337,4.319-16.265h30c0,15.237-4.259,23.458-7.681,30.064c-2.693,5.199-4.319,8.337-4.319,16.265c0,7.93,1.626,11.068,4.319,16.269c3.422,6.606,7.681,14.829,7.681,30.067s-4.259,23.46-7.681,30.066C301.959,201.215,300.333,204.354,300.333,212.284z"/><path style="fill:#C7C5CA;" d="M371,212.284h-30c0-15.238,4.259-23.46,7.681-30.067c2.693-5.2,4.319-8.339,4.319-16.269s-1.626-11.069-4.319-16.269c-3.422-6.606-7.681-14.829-7.681-30.066s4.259-23.458,7.681-30.064C351.374,84.35,353,81.212,353,73.284h30c0,15.237-4.259,23.458-7.681,30.064c-2.693,5.199-4.319,8.337-4.319,16.265c0,7.93,1.626,11.068,4.319,16.269c3.422,6.606,7.681,14.829,7.681,30.067s-4.259,23.46-7.681,30.066C372.626,201.215,371,204.354,371,212.284z"/></g><polygon style="fill:#FF9600;" points="512,328.339 256,328.339 235.984,343.339 235.984,343.339 235.984,343.339 256,384.72 313.01,384.72 319.329,358.339 512,358.339 "/><polygon style="fill:#FFD200;" points="0,328.339 0,358.339 192.671,358.339 198.99,384.72 256,384.72 256,358.339 256,343.339 256,328.339 "/></svg>
                        <h6 class="text-blue">Food Packaging Provider</h6>
                        <p>บรรจุภัณฑ์ใส่อาหาร ทนความร้อนได้เป็นอย่างดี ไม่มีสารเคมีอันตราย</p>
                    </div>
                </div>
                <div class="col-md-3 dotted p-2" data-aos="zoom-in">
                    <div class="text-center">
                        <svg viewBox="0 0 512 512" width="50" xmlns="http://www.w3.org/2000/svg"><path d="m64 192v221.539062c0 8.15625 6.613281 14.769532 14.769531 14.769532h177.230469l9.855469-214.15625-9.855469-214.152344c-105.867188 0-192 86.132812-192 192zm0 0" fill="#fef4f4"/><path d="m256 0v428.308594h177.230469c8.15625 0 14.769531-6.613282 14.769531-14.769532v-221.539062c0-105.867188-86.132812-192-192-192zm0 0" fill="#f7e7e7"/><path d="m245.554688 78.167969-62.664063 62.671875c-40.308594 40.300781-40.308594 105.894531 0 146.207031 16.492187 16.492187 37.210937 26.238281 58.703125 29.230469 4.777344.671875 9.589844 1.007812 14.40625 1.007812l9.855469-121.71875-9.855469-121.71875c-3.78125 0-7.5625 1.441406-10.445312 4.320313zm0 0" fill="#18af63"/><path d="m329.109375 140.839844-62.664063-62.671875c-2.882812-2.878907-6.664062-4.320313-10.445312-4.320313v243.433594c5.0625 0 10.121094-.363281 15.132812-1.113281 21.230469-3.109375 41.667969-12.816407 57.976563-29.121094 40.308594-40.3125 40.308594-105.90625 0-146.207031zm0 0" fill="#0a9f5c"/><path d="m241.59375 183.917969v27.824219l-6.183594-2.835938c-7.402344-3.398438-16.175781-.148438-19.574218 7.265625-3.40625 7.414063-.144532 16.175781 7.269531 19.585937l18.488281 8.476563v207.683594c4.777344.671875 9.589844 1.007812 14.40625 1.007812l9.855469-209.699219-9.855469-74.0625c-7.992188.195313-14.40625 6.722657-14.40625 14.753907zm0 0" fill="#8adc67"/><path d="m296.164062 216.171875c-3.398437-7.414063-12.160156-10.671875-19.574218-7.265625l-5.457032 2.5v-27.488281c0-8.152344-6.617187-14.769531-14.769531-14.769531-.121093 0-.242187.015624-.363281.015624v283.757813c5.0625 0 10.121094-.363281 15.132812-1.113281v-207.910156l17.761719-8.140626c7.414063-3.410156 10.675781-12.171874 7.269531-19.585937zm0 0" fill="#65c638"/><path d="m78.769531 398.769531c-3.003906 0-5.9375.917969-8.40625 2.625l-64 44.308594c-3.984375 2.757813-6.363281 7.296875-6.363281 12.144531v39.382813c0 8.15625 6.613281 14.769531 14.769531 14.769531h241.230469l9.855469-56.617188-9.855469-56.613281zm0 0" fill="#6f6b6e"/><path d="m505.636719 445.703125-64-44.308594c-2.46875-1.707031-5.402344-2.625-8.40625-2.625h-177.230469v113.230469h241.230469c8.15625 0 14.769531-6.613281 14.769531-14.769531v-39.382813c0-4.847656-2.378906-9.386718-6.363281-12.144531zm0 0" fill="#242627"/></svg>
                        <h6 class="text-blue">Safe for consumers</h6>
                        <p>บรรจุภัณฑ์กล่องกระดาษ เป็นมิตรกับสิ่งแวดล้อม ผลิตจากวัสดุธรรมชาติ 100%</p>
                    </div>
                </div>
                <div class="col-md-3 dotted p-2" data-aos="zoom-in">
                    <div class="text-center">
                        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" width="50" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.043 512.043" style="enable-background:new 0 0 512.043 512.043;" xml:space="preserve"><path style="fill:#FF7058;" d="M436.437,164.8H330.709v191.627h173.227v-86.251l-20.203-69.824C477.643,179.296,458.357,164.8,436.437,164.8"/><path style="fill:#84DBFF;" d="M478.645,269.291l-18.005-62.24c-3.104-10.699-13.056-18.187-24.203-18.187h-81.664v80.427H478.645z"/><polygon style="fill:#CDD6E0;" points="478.667,269.259 354.731,269.259 354.731,188.832 "/><path style="fill:#F2F2F2;" d="M478.645,269.291l-18.005-62.24c-3.104-10.699-13.056-18.187-24.203-18.187h-81.664L478.645,269.291z"/><path style="fill:#FFD15C;" d="M32,68.597h266.709c17.664,0,32,14.325,32,32v255.819H0V100.597C0,82.923,14.325,68.597,32,68.597"/><polygon style="fill:#F2F2F2;" points="216.747,68.651 216.747,153.205 204.373,140.832 191.403,153.803 178.443,140.832 165.483,153.803 152.501,140.832 139.371,153.803 126.421,140.832 113.899,153.355 113.899,68.651 "/><path style="fill:#334A5E;" d="M512.043,356.405v36.16h-512v-36.16h53.44c12.48-22.4,36.48-37.547,64-37.547c27.413,0,51.413,15.147,64,37.547h171.947c12.48-22.4,36.363-37.547,63.883-37.547c27.52,0,51.413,15.147,64,37.547H512.043z"/><path style="fill:#40596B;" d="M468.416,392.341c0,28.224-22.88,51.104-51.104,51.104s-51.083-22.88-51.083-51.104s22.869-51.104,51.083-51.104C445.547,341.237,468.416,364.117,468.416,392.341"/><path style="fill:#ACB3BA;" d="M437.856,392.341c0,11.339-9.195,20.523-20.523,20.523c-11.339,0-20.544-9.184-20.544-20.523c0-11.339,9.195-20.523,20.544-20.523C428.661,371.808,437.856,381.003,437.856,392.341"/><path style="fill:#40596B;" d="M168.544,392.341c0,28.224-22.891,51.104-51.104,51.104c-28.224,0-51.104-22.88-51.104-51.104s22.88-51.104,51.104-51.104C145.653,341.237,168.544,364.117,168.544,392.341"/><path style="fill:#ACB3BA;" d="M137.963,392.341c0,11.339-9.184,20.523-20.523,20.523s-20.533-9.184-20.533-20.523c0-11.339,9.195-20.523,20.533-20.523S137.963,381.003,137.963,392.341"/></svg>
                        <h6 class="text-blue">Delivery</h6>
                        <p>จัดส่งสินค้าทุกรายการ ถึงมือคุณ ทั่วประเทศไทย</p>
                    </div>
                </div>
            </div>

            <div class="text-center mt-7 mb-3">
                <h2 class="text-bold text-danger">NEW PRODUCTS</h2>
                <div class="row mt-4" data-aos="zoom-in">
                    <div class="col-md-6 col-lg-3 mb-3" v-for="product in $root.products" :key="product.index">
                        <div class="card item-shopping-cart">
                            <div class="tag-item-pro bg-tag-green">
                                <span class="text-white text-left"> {{product.id_type}}</span>
                            </div>
                            <img class="card-img-top img-fluid" :src="getImg(product.product_image)">
                            <div class="card-body">
                                <p class="text-right text-bold">{{product.product_name}}</p>
                                <p class="price-cart">ราคา {{product.crate_unit}} บาท</p>
                                <div class="d-flex">
                                    <button class="btn-order-card" @click="$root.addCart(product,0)"><i class="fas fa-cart-plus"></i> สั่งเลย</button>
                                    <button class="btn-detail-card" @click="showProduct(product)"><i class="fas fa-search"></i> ดูทันที</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  

            <!-- <div class="text-center mt-4 mb-5">
                <router-link class="btn btn-order text-white" to="/products">ดูสินค้าทั้งหมด</router-link>
            </div> -->
        </div>

        <div class="mt-7">
            <img src="../../dist/bg/bg1.jpg" class="img-fluid">
            <div class="bg-caption text-center" data-aos="fade-up">
                <h2 class="text-bold">บรรจุภัณฑ์ใส่อาหาร สามารถทนความร้อนได้เป็นอย่างดี</h2>
                <p class="text-facebook text-bold">เป็นมิตรกับสิ่งแวดล้อม ผลิตจากวัสดุธรรมชาติ</p>
                <!-- <router-link to="/products" class="btn btn-order text-light">สั่งเลย</router-link> -->
            </div>
        </div>

        
        <div class="container mt-10">
            <div class="text-center" data-aos="fade-up">
                <h2 class="text-bold text-danger">เลือกบรรจุภัณฑ์อาหาร จากชนิดอาหารของคุณ</h2>
            </div>
            <div class="row">
                <div class="col-md-4" v-for="type in typeProduct" :key="type.index">
                    <div class="card">
                        <img :src="getImgType(type.path_file)" class="img-fluid card-img-top">
                        <div class="bg-orange d-flex justify-content-center align-items-center">
                            <h5 class="text-white text-bold">{{type.type_name}}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="mt-7">
            <img src="../../dist/bg/bg4.jpg" class="img-fluid">
            <div class="bg-caption text-right mr-5">
                <h2 class="text-bold">บรรจุภัณฑ์ใส่อาหาร สามารถทนความร้อนได้เป็นอย่างดี</h2>
                <p class="text-facebook text-bold">เป็นมิตรกับสิ่งแวดล้อม ผลิตจากวัสดุธรรมชาติ</p>
                <button class="btn btn-order text-light">สั่งเลย</button>
            </div>
        </div> -->
        <!-- Modal -->
        <div v-show="$root.modal" class="modals">
            <!-- Modal content -->
            <div class="modal-contents">
                <span class="closes" @click="$root.modal = false">&times;</span>
                <div class="row">
                    <div class="col-md-6">
                        <div id="carouselId" class="carousel fade" data-ride="carousel" data-aos="fade-down">
                            <div class="carousel-inner" role="listbox">
                                <div class="carousel-item" v-for="(img,index) in imgDetailProducts" :key="img.index" v-bind:class="((index) === 0) ? 'active' : ''">
                                    <img :src="getImg(img.path_file)" class="img-fluid">
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#carouselId" role="button" data-slide="prev">
                                <span><i class="fas fa-chevron-left text-orange"></i></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carouselId" role="button" data-slide="next">
                                <span><i class="fas fa-chevron-right text-orange"></i></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h5 class="mt-3">{{$root.form.product_name}}</h5>
                        <div class="d-flex mt-3">
                            <div class="col">
                                <label class="text-bold text-orange">จำนวน</label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <button class="btn btn-secondary btn-sm" type="button" @click="$root.form.amount > 1 ? $root.form.amount -= 1 : 1"><i class="fas fa-minus"></i></button>
                                    </div>
                                    <input type="number" class="form-control fomr-control-sm text-center" v-model="$root.form.amount" readonly>
                                    <div class="input-group-prepend">
                                        <button class="btn btn-primary btn-sm" type="button" @click="$root.form.amount += 1"><i class="fas fa-plus"></i> </button>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div><b class="text-gray">ราคาต่อชิ้น</b></div>
                                    <div> {{piecePerItem}} </div>
                                    <div><b class="text-gray">บาท/ชิ้น</b></div>
                                </div>
                            </div>
                            <div class="col">
                                <label class="text-bold text-orange">ประเภท</label>
                                <select class="form-control mb-3" v-model="piece" @change="selectedType($event)">
                                    <option :value="$root.form.crate" data-foo="ลัง">ลัง</option>
                                    <option :value="$root.form.pack" data-foo="แพ็ก">แพ็ก</option>
                                </select>
                                <div class="d-flex justify-content-between">
                                    <div><b class="text-gray">หน่วย</b></div>
                                    <div> {{piece * $root.form.amount}} </div>
                                    <div><b class="text-gray">ชิ้น</b></div>
                                </div>
                            </div>
                        </div><hr>
                        <div class="d-flex justify-content-between">
                            <div><b>ราคารวม</b></div>
                            <div class="text-bold text-orange"> {{ (piecePerItem * (piece*$root.form.amount)) | numberFormat }} </div>
                            <div><b>บาท</b></div>
                        </div>
                        <button class="btn-sm btn-order-card" @click="$root.addCart($root.form,1)"><i class="fas fa-cart-plus"></i> สั่งเลย</button>
                        <div class="mt-3">
                            <b>รายละเอียดสินค้า:</b><br>
                            <span class="text-gray">{{$root.form.detail_more}}</span><br>
                            <span class="text-gray">วัสดุ : {{$root.form.material}}</span><br>
                            <span class="text-gray">ขนาด : {{$root.form.size}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br><br><br><br>
        <Footer/>
    </div> <!-- end root -->
</template>
<style scoped>

</style>
<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
    export default {
        components : {
            Header,Footer,
        },
        data(){
            return {
                banners:{},
                activeBanner: true,
                counter: 1,
                piece: '',
                piecePerItem:'',
                imgDetailProducts:{},
                typeProduct:{}
            }
        },
        methods: {
            getImgType(img){
                return 'http://pgm01.toonjob.com/2019/BannKlong/image/typeProduct/'+img
            },
            listTypeProduct(){
                this.axios.get('http://pgm01.toonjob.com/2019/BannKlong/project/dataTypeProduct')
                .then((res) => {
                    this.typeProduct = res.data
                })
            },
            getImg(img){
                return 'http://pgm01.toonjob.com/2019/BannKlong/image/products/'+img
            },
            listBanner(){
                this.axios.get('http://pgm01.toonjob.com/2019/BannKlong/project/dataBanner')
                .then((response) => {
                    this.banners = response.data
                })
            },
            getImgBanner(img){
                let image = 'http://pgm01.toonjob.com/2019/BannKlong/image/banners/'+img
                return image
            },
            showProduct(product) {
                this.$root.modal = true
                this.$root.form.fill(product)
                this.piece = this.$root.form.crate
                this.piecePerItem = this.$root.form.crate_unit
                this.$root.form.product_unit = 'ลัง'
                this.$root.form.amount = 1
                this.axios.post('http://pgm01.toonjob.com/2019/BannKlong/project/listImageProduct' ,{product_id:this.$root.form.product_id})
                .then((res) => {
                    this.imgDetailProducts = res.data
                })
            },

            selectedType(e){
                this.$root.form.product_unit = e.target.options[e.target.options.selectedIndex].dataset.foo
                if(e.target.value == this.$root.form.crate) {
                    this.piecePerItem = this.$root.form.crate_unit
                }else {
                    this.piecePerItem = this.$root.form.pack_unit
                }
            },
        },
        created() {
            this.$Progress.start()    
             this.listBanner()
             this.listTypeProduct()
            this.$Progress.finish()
        },
    }
</script>



// WEBPACK FOOTER //
// src/frontEnd/HomePage.vue